import {
    clearProducts,
} from '../../scheduleSurgery/redux/actions';
import {
    VISIBLE,
} from 'src/constants/appConstants';

const reportPaymentBtnClickHandlerUtil = ({
    reportPaymentButtonVisibility,
    dispatch,
    reportUsageFormObj,
    setShowReportPayment,
    setReportPaymentGridData,
    setCurrencyFormat,
    itemTableData,
    isValidLotSerial,
    showUnidInfoScreen,
    storeUnidSurgeryLocalState,
    validatingSerialAndQty
}) => {
    if (reportPaymentButtonVisibility === VISIBLE) {
        dispatch(clearProducts());
        let qty = 'not_required';
        let flag;
        if (
            reportUsageFormObj.products &&
            reportUsageFormObj.products.length > 0
        ) {
            reportUsageFormObj.products.every((item) => {
                if (item?.usedQuantity > 0 || item?.otherQuantity > 0) {
                    if (
                        item?.lotSerialNumber !== '' ||
                        item?.lotSerialNumber !== undefined
                    ) {
                        qty = 'serial';
                    }
                } else {
                    qty = 'serial';
                }
            });
        }
        if (qty === 'serial') {
            // validatingSerialAndQty is expected to be called outside this util
            validatingSerialAndQty();
            flag = isValidLotSerial(itemTableData);
        } else flag = true;

        if (flag) {
            setShowReportPayment(true);
            if (
                reportUsageFormObj.products &&
                reportUsageFormObj.products.length > 0
            ) {
                setReportPaymentGridData(
                    reportUsageFormObj.products
                        .map((item) => ({
                            ...item,
                            cfn: item.productCFN,
                            isSelected: false,
                            isBundleItem: item.bundleItem ? true : false,
                            isBundleExpanded: false,
                            basePrice: setCurrencyFormat(item.unitPrice),
                            lotSerial: itemTableData?.filter(
                                (product) => product.unqId === item.unqId
                            )?.[0]?.lotSerial,
                        }))
                        .filter((item) => !item.isAccountOwned)
                );
            }
            setShowReportPayment(true);
            if (showUnidInfoScreen) {
                storeUnidSurgeryLocalState();
            }
        }
    } else {
        setShowReportPayment(true);
        if (
            reportUsageFormObj.products &&
            reportUsageFormObj.products.length > 0
        ) {
            setReportPaymentGridData(
                reportUsageFormObj.products
                    .map((item) => ({
                        ...item,
                        cfn: item.productCFN,
                        isSelected: false,
                        isBundleItem: item.bundleItem ? true : false,
                        isBundleExpanded: false,
                        basePrice: setCurrencyFormat(item.unitPrice),
                        lotSerial: itemTableData?.filter(
                            (product) => product.unqId === item.unqId
                        )?.[0]?.lotSerial,
                    }))
                    .filter((item) => !item.isAccountOwned)
            );
        }
        setShowReportPayment(true);
        if (showUnidInfoScreen) {
            storeUnidSurgeryLocalState();
        }
    }
};

export default reportPaymentBtnClickHandlerUtil;